webpackJsonp([64],{

/***/ 1337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		TabsComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent___default.a
	},
	data: function data() {
		return {
			tabs: [{
				id: 1,
				title: 'Company',
				link: { name: 'company' }
			}, {
				id: 2,
				title: 'Subsidiaries',
				link: { name: 'subsidiaries' }
			}]
		};
	},

	name: 'configuration'
});

/***/ }),

/***/ 1419:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Configuration.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1504:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1419);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("05b1de7e", content, true);

/***/ }),

/***/ 1665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1504)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1337),
  /* template */
  __webpack_require__(1665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6df10d43",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/64.d4218bb98bb0bad7ecfd.js